import React from 'react';
import Box from '@mui/material/Box';
import UserOverlay from '../user/UserOverlay';
import RobotPage from '../robots/RobotPage';
import AgreementOverlay from '../agreements/AgreementOverlay';
import GlobalSnackbars from './GlobalSnackbars';
import { Theme, useMediaQuery } from '@mui/material';
import Stack from '@mui/material/Stack';
import MainNavigationBar from './MainNavigationBar';
import AnnouncementBanner from './AnnouncementBanner';
import ReportOverlay from 'components/pages/ReportOverlay';

const CentralContentBlock: React.FC<{
  children: React.ReactNode;
  isNavOpen: boolean;
  onNavChangeHandler: () => void;
}> = ({ children, isNavOpen, onNavChangeHandler }) => {
  const matchesSmUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <Box
      data-testid="central-content-block"
      sx={{
        height: '100%',
        position: { xs: undefined, sm: 'relative' },
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Stack direction="row" sx={{ height: '100%', overflow: 'hidden', width: '100%' }}>
        {matchesSmUp && (
          <MainNavigationBar isNavOpen={isNavOpen} onNavChangeHandler={onNavChangeHandler} />
        )}
        <Stack
          spacing={1}
          sx={{
            width: '100%',
            overflow: 'hidden',
            height: '100%',
            pr: { xs: 0, sm: 1 },
            pl: 0,
            pb: { xs: 0, sm: 1 },
          }}
        >
          <AnnouncementBanner />
          <Box
            sx={(theme) => ({
              overflowY: 'hidden',
              height: '100%',
              width: '100%',
              backgroundColor: '#fff',
              borderRadius: theme.spacing(1),
            })}
          >
            <Box
              sx={{
                overflowY: 'auto',
                height: '100%',
                width: '100%',
              }}
            >
              {children}
            </Box>
          </Box>
        </Stack>
      </Stack>
      <RobotPage />
      <UserOverlay />
      <AgreementOverlay />
      <ReportOverlay />
      <GlobalSnackbars />
    </Box>
  );
};

export default CentralContentBlock;
